import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { DocumentCategory } from "@common/types/documentCategory";
import {
    createDocumentCategoryBodySchema,
    updateDocumentCategoryBodySchema,
} from "@common/schemas/documentCategory/document-category.schema";

export interface DocumentCategoryStat {
    id: string;
    parentCategoryId?: string;
    label: string;
    count: number;
    groupCount: number;
}

const c = initContract();

export const documentCategoryContract = c.router(
    {
        getDocumentCategories: {
            path: "/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            method: "GET",
            responses: {
                200: c.type<{ categories: DocumentCategory[] }>(),
                404: c.noBody(),
            },
        },
        getDocumentCategoryStatistics: {
            path: "/:workspaceId/statistics",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            method: "GET",
            responses: {
                200: c.type<DocumentCategoryStat[]>(),
                404: c.noBody(),
            },
            query: z.object({
                entityIds: z.array(z.coerce.number()).optional(),
                start: z.coerce.date().optional(),
                end: z.coerce.date().optional(),
            }),
        },
        createDocumentCategory: {
            path: "/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            method: "POST",
            body: createDocumentCategoryBodySchema,
            responses: {
                201: c.type<DocumentCategory>(),
                400: c.type<{ message: string }>(),
            },
        },
        updateDocumentCategory: {
            path: "/:workspaceId/:categoryId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
                categoryId: z.string().uuid(),
            }),
            method: "PATCH",
            body: updateDocumentCategoryBodySchema,
            responses: {
                200: c.type<DocumentCategory>(),
                400: c.type<{ message: string }>(),
                404: c.noBody(),
            },
        },
        deleteDocumentCategory: {
            path: "/:workspaceId/:categoryId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
                categoryId: z.string().uuid(),
            }),
            method: "DELETE",
            responses: {
                200: c.noBody(),
                400: c.type<{ message: string }>(),
                404: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/document-category",
    },
);
